import { render } from "./face.vue?vue&type=template&id=01a59830&ts=true"
import script from "./face.vue?vue&type=script&lang=ts"
export * from "./face.vue?vue&type=script&lang=ts"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__